import {
  ForceOrdreControllerApi,
  UpdateEntitesRattachementViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import {
  UpdateEntiteRattachementFormValues,
  ValidateFunction,
} from 'components/UpdateEntitesRattachements/types';

function buildValidateFunction(
  refController: ForceOrdreControllerApi,
  dossierId: string,
): ValidateFunction {
  return (
    values: UpdateEntiteRattachementFormValues,
    key: keyof UpdateEntiteRattachementFormValues,
    field: UpdateEntitesRattachementViolationDtoFormFieldEnum,
    value: unknown,
  ) => {
    const request = {
      ...values,
      [key]: value,
    };

    return refController.validateUpdateEntitesRattachementFieldFOUsingPOST(
      field,
      dossierId,
      request,
    );
  };
}

export default buildValidateFunction;
